<template>
  <main id="authorProfit" v-if="config.status.authed">
    <div id="legacy">
      <iframe name="legacyFrame" src=""></iframe>
      <form id="legacyForm" ref="legacyForm" target="legacyFrame" action="https://legacy.sasmango.com/sas/author/prolist?type=profit" method="POST">
        <input type="hidden" name="firebaseToken" ref="legacyToken" value="" />
      </form>
    </div>
  </main>
</template>

<script>
export default {
  name: 'authorProfit',
  components: {
  },
  data () {
    return {
      config: {
        status: {
          authed: false
        }
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function () {
      this.auth()
      this.$nextTick(() => {
        this.loadLegacy()
      })
    },
    auth: function () {
      let auths = this.$store.getters['author/get']('authority')
      let permit = this.$route.meta.permit
      if (!auths.includes(permit)) {
        this.$router.push('/')
      } else {
        this.$set(this.config.status, 'authed', true)
      }
    },
    loadLegacy: function () {
      this.$firebase.auth().currentUser.getIdToken(true).then(token => {
        this.$refs.legacyToken.value = token
        this.$nextTick(() => {
          this.$refs.legacyForm.submit()
        })
      })
    }
  }
}
</script>

<style lang="scss">
#authorProfit {
  #legacy {
    width: 100%;
    height: 100%;
    iframe {
      display: block;
      width: 100%;
      height: 100%;
      border: none;
    }
  }
}
</style>
